/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-05-10 11:23:08
 * @Description: 
 */
/**
 * 用户 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const user = {
  /** ***********普通用户BEGIN***************/
  // 列表
  list (params) {
    return axios.get(api + 'user/list', { params: params })
  },
  // 消费排行
  consumeRanking (params) {
    return axios.get(api + 'consume/ranking', { params: params })
  },
  // 修改状态
  status (params) {
    return axios.post(api + 'user/status', qs.stringify(params))
  },
  // 获取用户的所属分组
  usergroup (params) {
    return axios.get(api + 'usergroup/detail', { params: params })
  },
  // 修改用户所属分组
  usergroupedit (params) {
    return axios.post(api + 'usergroup/edit', qs.stringify(params))
  },
  // 详情
  detail (params) {
    return axios.get(api + 'user/detail', { params: params })
  },

  // 修改密码
  editpwd (params) {
    return axios.post(api + 'user/edit-pwd', qs.stringify(params))
  },
  // 扣余额
  userconsumed (params) {
    return axios.post(api + 'user/consumed', qs.stringify(params))
  },
  // 给用户充值
  userrecharge (params) {
    return axios.post(api + 'user/recharge', qs.stringify(params))
  },
  // 消费记录
  consumelist (params) {
    return axios.get(api + 'user/consume/list', { params: params })
  },
  // 用户地址
  addresslist (params) {
    return axios.get(api + 'user/address/list', { params: params })
  },
  // 用户地址详情
  addressdetail (params) {
    return axios.get(api + 'user/address/detail', { params: params })
  },
  // 用户地址修改
  addressedit (params) {
    return axios.post(api + 'user/address/edit', qs.stringify(params))
  },
  //注销记录
  cancellog (params) {
    return axios.get(api + 'user/cancellog/list', { params: params })
  },
  //用户修改积分
  changepoint (params) {
    return axios.post(api + 'user/changepoint', qs.stringify(params))
  },
}

// 导出接口
export default user
